import DataHeaderDetail from "components/DataHeaderDetail/DataHeaderDetail";
import DropDownButton from "components/DropDownButton/DropDownButton";
import { Row } from "components/styles";
import TimerIcon from "icons/TimerIcon";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { configSessionStorage } from "services/storage/config";

const HeaderComponent = ({
    spaceTypeList
}) => {
    const registerButtonOptionsClick = (goToPath, spaceTypeId) => {
        goToPath();
        configSessionStorage.spaceAdmin.spaceTypeId.set(spaceTypeId);
    }
    return (
        <Row>
            <DataHeaderDetail 
                icon={<TimerIcon/>}
                text="Administrador de Espacios"
                width="300px"/>
            <DropDownButton 
                text="Registrar espacio"
                itemSize="medium"
                items={spaceTypeList.map(({ id, name }) => ({
                    text: name,
                    path: ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN_REGISTER,
                    onClick: goToPath => registerButtonOptionsClick(goToPath, id)
                }))}/>
        </Row>
    );
}

export default HeaderComponent;